import React from 'react';

const JurisdictionsDisclaimers = () => (
	<div className="container main">
		<h2>Avertissements</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-12">
				<h4>Canada</h4>
				<p>
					La portée des avis de rappel de biens de consommation du Canada englobe les produits de consommation définis en vertu de la Loi canadienne sur la sécurité des produits de consommation (LCSPC) comme étant
					un «produit — y compris tout composant, partie ou accessoire de celui-ci — dont on peut raisonnablement s’attendre à ce qu’un individu l’obtienne en vue d’une utilisation à des fins
					non commerciales, notamment à des fins domestiques, récréatives ou sportives. Est assimilé à un tel produit son emballage.»
				</p>
				<p>
					Elle englobe également les produits cosmétiques.  Par « produit cosmétique », la loi sur les aliments et les drogues entend « notamment les substances ou mélanges de substances fabriqués,
					vendus ou présentés comme pouvant servir à embellir, purifier ou modifier le teint, la peau, les cheveux ou les dents,
					y compris les désodorisants et les parfums ».
				</p>
				<p>Les domaines qui ne sont pas visés par les avis de rappel de produits cosmétiques et de consommation comprennent :</p>
				<ul>
					<li>Les explosifs au sens de la section 2 de la Loi sur les explosifs.</li>
					<li>Les instruments au sens de la section 2 de la Loi sur les aliments et drogues.</li>
					<li>Les drogues au sens de la section 2 de la Loi sur les aliments et drogues.</li>
					<li>Les produits antiparasitaires au sens du paragraphe 2(1) de la Loi sur les produits antiparasitaires.</li>
					<li>Les véhicules au sens de la section 2 de la Loi sur la sécurité automobile, et une partie d’un véhicule qui en fait partie intégrante - tel qu’il est assemblé ou modifié avant sa vente au premier acheteur au détail - y compris une partie d’un véhicule qui remplace ou modifie une telle partie.</li>
					<li>Les aliments au sens de la section 2 de la loi relative aux aliments du bétail.</li>
					<li>Les engrais au sens de la section 2 de la Loi sur les engrais.</li>
					<li>Les bâtiments au sens de la section 2 de la Loi de 2001 sur la marine marchande du Canada.</li>
					<li>Les armes à feu au sens de la section 2 du Code criminel.</li>
					<li>Les munitions au sens de la sous-section 84(1) du Code criminel.</li>
					<li>Les chargeurs au sens de la sous-section 84(1) du Code criminel.</li>
					<li>Les arbalètes au sens de la sous-section 84(1) du Code criminel.</li>
					<li>Les dispositifs prohibés au sens des paragraphes (a) à (d) de la définition «dispositif prohibé» de la sous-section 84(1) du Code criminel.</li>
					<li>Les végétaux au sens de la section 3 de la Loi sur la protection des végétaux, à l’exception des haricots jéquirity (abrus precatorius)</li>
					<li>Les semences au sens de la section 2 de la loi sur les semences, à l’exception des haricots jéquirity (abrus precatorius).</li>
					<li>Les substances contrôlées au sens de la sous-section 2(1) de la Loi réglementant certaines drogues et autres substances.</li>
					<li>Les produits aéronautiques au sens de la sous-section 3(1) de la Loi sur l’aéronautique.</li>
					<li>Les animaux au sens de la sous-section 2(1) de la Loi sur la santé des animaux.</li>
				</ul>
			</div>
		</div>
		<hr/>

		<div className="row">
			<div className="col-sm-12">
				<h4>Commission européenne</h4>
				<p>En l’absence de précision dans l’alerte Safety Gate/RAPEX, le risque est réputé menacer la santé et la sécurité des consommateurs.</p>
				<p>Depuis 2010, les alertes incluent également les mesures prises à l’encontre des produits non alimentaires destinés aux professionnels et des produits non alimentaires présentant des risques autres, tels que des risques pour l’environnement.</p>
				<p>Depuis 2019, les alertes qui étaient auparavant diffusées uniquement à titre d’information entre les autorités nationales sont également publiées sur le site web du système d’alerte, lorsque les autorités nationales le jugent nécessaire.</p>
				<p>Les marques déposées, dessins et logos qui apparaissent dans la présente liste peuvent avoir été utilisés par des acteurs économiques en contradiction avec le droit de la propriété intellectuelle et, par conséquent, à l’insu ou sans l’autorisation de leur propriétaire légitime.</p>
			</div>
		</div>
		<hr/>

		<div className="row">
			<div className="col-sm-12">
				<h4>Japon</h4>
				<p>Nos avis de rappel concernent les produits de consommation tels que les appareils électroménagers, les articles ménagers, les articles de papeterie, les produits de divertissements, entre autres. Sont exclus les produits alimentaires, les véhicules et les produits pharmaceutiques (y compris les cosmétiques).</p>
			</div>
		</div>
		<hr/>

		<div className="row">
			<div className="col-sm-12">
				<h4>États-Unis</h4>
				<p>
					La Commission de la Sécurité des Produits de Consommation a compétence sur de nombreux types de produits de consommation, des cafetières aux jouets, en passant par les tondeuses à gazon et les feux d'artifice.
					Toutefois, certains types de produits de consommation sont couverts par d'autres organismes fédéraux.
					Veuillez consulter cette liste de produits couverts par d'autres agences :
					<a href="https://www.cpsc.gov/Regulations-Laws--Standards/Products-Outside-CPSCs-Jurisdiction/" target="_blank">https://www.cpsc.gov/Regulations-Laws--Standards/Products-Outside-CPSCs-Jurisdiction/</a>.
				</p>
			</div>
		</div>
		<hr/>
	</div>
);

export default JurisdictionsDisclaimers ;



// WEBPACK FOOTER //
// ./src/views/static/fr/jurisdictions-disclaimers.js